import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { FolderOpen, Download, X } from 'lucide-react';
import { getAuthHeader } from '../services/tokenService';

const BASE = process.env.REACT_APP_BACKEND_URL;
const ICON = { mandat: 'Mandat', souscription: 'Souscription', recu: 'Reçu', convention: 'Convention' };

const telecharger = async (path, nom) => {
  try {
    const r = await axios.get(`${BASE}${path}`, { headers: getAuthHeader(), responseType: 'blob' });
    const url = URL.createObjectURL(r.data);
    const a = document.createElement('a');
    a.href = url; a.download = `${nom}.pdf`; a.click();
    URL.revokeObjectURL(url);
  } catch { toast.error('Téléchargement impossible'); }
};

export default function StripeDossierLien({ eventId }) {
  const [data, setData] = useState(null);
  const [open, setOpen] = useState(false);
  const charger = async () => {
    setOpen(true);
    if (data) return;
    try {
      const r = await axios.get(`${BASE}/api/webhook/stripe/admin/evenements/${eventId}/dossier`, { headers: getAuthHeader() });
      setData(r.data);
    } catch (e) { toast.error(e.response?.data?.detail || 'Dossier introuvable'); setOpen(false); }
  };
  return (
    <span className="relative">
      <button type="button" onClick={charger} className="inline-flex items-center gap-1 rounded-lg border border-slate-300 px-2 py-1 text-xs hover:bg-slate-50" data-testid={`stripe-dossier-${eventId}`}>
        <FolderOpen className="h-3.5 w-3.5" /> Dossier
      </button>
      {open && data && (
        <div className="fixed right-6 top-24 z-50 w-96 max-h-[70vh] overflow-auto rounded-xl border border-slate-200 bg-white p-4 shadow-2xl text-xs break-words" data-testid={`stripe-dossier-panel-${eventId}`}>
          <div className="flex items-center mb-2">
            <p className="font-semibold text-slate-800">Dossier lié</p>
            <button type="button" onClick={() => setOpen(false)} className="ml-auto p-1 rounded hover:bg-slate-100" data-testid={`stripe-dossier-fermer-${eventId}`}><X className="h-3.5 w-3.5" /></button>
          </div>
          {data.client && <p className="text-slate-500 mb-2">Client Stripe : {data.client}</p>}
          {data.elements.length === 0 && <p className="text-slate-400">Aucun mandat, souscription ou reçu retrouvé pour cette notification.</p>}
          <ul className="space-y-2">
            {data.elements.map((el, i) => (
              <li key={i} className="rounded-lg bg-slate-50 p-2" data-testid={`stripe-dossier-element-${eventId}-${i}`}>
                <p className="font-medium text-slate-800 [overflow-wrap:anywhere]"><span className="text-slate-400">{ICON[el.type]} · </span>{el.titre}</p>
                <p className="text-slate-500">{[el.statut, ...(el.details || [])].filter(Boolean).join(' · ')}</p>
                {el.pdf && (
                  <button type="button" onClick={() => telecharger(el.pdf, el.titre)} className="mt-1 inline-flex items-center gap-1 text-orange-700 hover:underline" data-testid={`stripe-dossier-pdf-${eventId}-${i}`}>
                    <Download className="h-3 w-3" /> Télécharger le PDF
                  </button>
                )}
              </li>
            ))}
          </ul>
        </div>
      )}
    </span>
  );
}
